import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Input, message } from 'antd';
import { finish3rdPrize } from '../../redux/actions/4DCollection/finish4D';
import { toggle3rdPrizeFinishModal } from '../../redux/actions/4DCollection/toggleFinish4DModal';

class Finish3rdPrizeModal extends React.Component {
      constructor(props) {
            super(props);
            this.form = React.createRef();
      }
      onFinish = async (values) => {
            await this.props.onFinish({ id: this.props.result?.thirdPrize?.id, ...values }, this.props.token);
            if (this.props.message) {
                  message.success(this.props.message);
                  this.props.onClose();
            }
            if (this.props.error) {
                  message.error(this.props.error);
            }
      }
      onFinishFailed = (errors) => {
            console.log(errors)
      }
      handleCancel = () => {
            this.props.onClose();
      }
      render() {
            const number = this.props.result?.thirdPrize?.number;
            return (
                  <Modal
                        title="Finish 3rd Prize"
                        key="finish-3rdp-modal"
                        centered
                        visible={this.props.visible}
                        okButtonProps={{ form: 'finish-3rdp-form', key: 'submit', htmlType: 'submit' }}
                        confirmLoading={this.props.loading}
                        onCancel={this.handleCancel}
                        okText="Save"
                        loading={this.props.loading}
                  >
                        <Form
                              key={number + "form"}
                              layout="vertical"
                              ref={this.form}
                              id="finish-3rdp-form"
                              name="basic"
                              onFinish={this.onFinish}
                              onFinishFailed={this.onFinishFailed}>

                              <Form.Item
                                    key={number}
                                    name="number"
                                    label="Prize Number"
                                    rules={[
                                          {
                                                required: true,
                                                message: 'Require!',
                                          },
                                          {
                                                pattern: new RegExp(`^${number}$`),
                                                message: "Need to confirm the prize"
                                          }
                                    ]}>
                                    <Input />
                              </Form.Item>
                        </Form>
                  </Modal>
            );
      }
}

const mapStateToProps = state => ({
      visible: state.fourDCollection.finish3rdPrizeVisible,
      loading: state.fourDCollection.loading,
      token: state.auth.token,
      error: state.fourDCollection.error,
      message: state.fourDCollection.message,
      result: state.fourDCollection.result
})

const mapDispatchToProps = dispatch => ({
      onFinish: (obj, token) => dispatch(finish3rdPrize(obj, token)),
      onClose: () => dispatch(toggle3rdPrizeFinishModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Finish3rdPrizeModal);